import React from 'react';

function SponcerLargebanner({ className = '' }) {
  // Google AdSense Large Leaderboard size: 970x90px
  return (
    <div className={`w-full max-w-[970px] h-[90px] mx-auto ${className}`}>
      <div className="w-full h-full bg-gray-200 border border-gray-300 rounded flex items-center justify-center overflow-hidden">
        <div className="text-center px-4">
          <p className="text-gray-500 font-medium text-sm">Advertisement</p>
          <p className="text-gray-400 text-xs mt-1">970 × 90</p>
        </div>
      </div>
    </div>
  );
}

// Fix component name to follow React naming convention (PascalCase)
export default SponcerLargebanner;